import './DocumentationPage.css'
import React, {useEffect, useState} from 'react';
import axios from 'axios';


function GetMarkdownFile(softwareKey, filename, setMarkdown) { 
    const token = localStorage.getItem('token'); 
    axios.get('/api/documentation/' + filename, {
      headers: {'Authorization': `Token ${token}`}, 
      params: {'softwareKey': `${softwareKey}`}
    })
    .then(reponse => {
        if (reponse.status === 200)
        {
            setMarkdown(reponse.data.docs); 
        }
    })
    .catch(error => {
        setMarkdown(''); 
    }) 
}



function GetAllMarkdownFilesForSoftware(softwareKey, setAllDocuments) { 
    const token = localStorage.getItem('token'); 

    axios.get('/api/documentation/', {
      headers: {'Authorization': `Token ${token}`}, 
      params: {'softwareKey': `${softwareKey}`}
    })
    .then(reponse => {
        if (reponse.status === 200) {
            setAllDocuments(reponse.data["documentation"])
        }
    })
    .catch(error => {
        setAllDocuments([])
    }) 
}


function OtherPages({name, softwareKey, fileName, selectedFile, setMarkdown, setSelectedFile}) {
    const [allDocuments, setAllDocuments] = useState([]); 

    useEffect(() => {
        GetAllMarkdownFilesForSoftware(softwareKey, setAllDocuments)
    }, [setAllDocuments, softwareKey])

    const onClick = (event) => {
        setSelectedFile(event.target.id); 
        GetMarkdownFile(softwareKey, event.target.id, setMarkdown);
    }

    if (allDocuments.length === 0)
        return (<></>)

    return (
        <div>
            {
                allDocuments.map((obj, index) => {
                    const selectedColor = obj === selectedFile ? '#969696' : "#555555";
                    return (
                        <div style={{margin:5, fontSize:12}} key={obj + 1}> 
                            <label id={obj} style={{
                                cursor:'pointer',
                                color:selectedColor
                            }} onClick={onClick} key={obj + 1}>{obj}</label>
                        </div> 
                )})
            }
        </div>
    )
}


function SoftwareDetails({softwareName, softwareKey, selectedFile, setMarkdown, setSelectedFile}) {
    const [allDocuments, setAllDocuments] = useState([]); 

    useEffect(() => {
        GetAllMarkdownFilesForSoftware(softwareKey, setAllDocuments)
    }, [setAllDocuments, softwareKey])

    const onClick = (event) => {
        // setMarkdown('')
        setSelectedFile(event.target.id); 
        GetMarkdownFile(softwareKey, event.target.id, setMarkdown);
    }

    if (allDocuments.length === 0)
        return (<></>)

    return (
        <details style={{padding:5, color:'#555555', fontSize:12}}> 
            <summary>{softwareName}</summary>
            {
                allDocuments.map((obj, index) => {
                    const selectedColor = obj === selectedFile ? '#969696' : "#555555";
                    return (
                        <div style={{margin:5}} key={obj + index + 1}> 
                            <label id={obj} style={{
                                cursor:'pointer',
                                color:selectedColor
                            }} onClick={onClick} key={obj + index + 2}>{obj}</label>
                        </div> 
                )})
            }
        </details>
    )
}


function DocumentView({markdown}) {
    const markup = {__html: markdown}
    return (
        <div class='DocumentationPage' className='DocumentationPage' dangerouslySetInnerHTML={markup}/> 
    )
}


function DocumentNavigation({selectedFile, markdown, setSelectedFile, setMarkdown, entitledProductNames}) {

    const filterProduct = (productName) =>
        entitledProductNames.some(name => name.toLowerCase() === productName.toLowerCase());

    return  (
        <div style={{marginTop: 25}}>
            <OtherPages name="Intro" softwareKey={""} selectedFile={selectedFile} setMarkdown={setMarkdown} setSelectedFile={setSelectedFile}/>        
            {filterProduct("Canvas")                && <SoftwareDetails softwareName={"Canvas"}               softwareKey={"canvas"}      selectedFile={selectedFile} setMarkdown={setMarkdown} setSelectedFile={setSelectedFile}/>}
            {filterProduct("Venue")                 && <SoftwareDetails softwareName={"Venue"}                softwareKey={"venue"}       selectedFile={selectedFile} setMarkdown={setMarkdown} setSelectedFile={setSelectedFile}/>}
            {filterProduct("SpatializationPlugins") && <SoftwareDetails softwareName={"Controller/Renderer"}  softwareKey={"SpatializationPlugins"} selectedFile={selectedFile} setMarkdown={setMarkdown} setSelectedFile={setSelectedFile}/>}
            {filterProduct("Canvas-Live")           && <SoftwareDetails softwareName={"Canvas-Live"}          softwareKey={"Canvas-Live"} selectedFile={selectedFile} setMarkdown={setMarkdown} setSelectedFile={setSelectedFile}/>}
            {filterProduct("Touch")                 && <SoftwareDetails softwareName={"Touch"}                softwareKey={"touch"}       selectedFile={selectedFile} setMarkdown={setMarkdown} setSelectedFile={setSelectedFile}/>}
            {filterProduct("SphereAuralizer")       && <SoftwareDetails softwareName={"Auralizer (Legacy)"}   softwareKey={"SphereAuralizer"}   selectedFile={selectedFile} setMarkdown={setMarkdown} setSelectedFile={setSelectedFile}/>}
            {filterProduct("Auralizer-v2")          && <SoftwareDetails softwareName={"Auralizer"}            softwareKey={"Auralizer-v2"}   selectedFile={selectedFile} setMarkdown={setMarkdown} setSelectedFile={setSelectedFile}/>}
            {filterProduct("Autocheck")             && <SoftwareDetails softwareName={"Autocheck"}            softwareKey={"Autocheck"}   selectedFile={selectedFile} setMarkdown={setMarkdown} setSelectedFile={setSelectedFile}/>}
            {filterProduct("Spatializer")           && <SoftwareDetails softwareName={"Spatializer"}          softwareKey={"spatializer"} selectedFile={selectedFile} setMarkdown={setMarkdown} setSelectedFile={setSelectedFile}/>}
        </div>
    )
}

function DocumentationPage() {
    const [selectedFile, setSelectedFile] = useState(''); 
    const [markdown, setMarkdown] = useState(''); 
    const [entitledProductNames, setEntitledProductNames] = useState([]);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) return;

        axios.get('/api/myProducts/', {
            headers: {'Authorization': `Token ${token}`},
        })
        .then(response => {
            if (response.status === 200) {
                setEntitledProductNames(response.data.products);
            }
        })
        .catch(() => setEntitledProductNames([]));
    }, []);

    /// Get An initial markdown file for view
    const initialSoftwareKey = ''; /// Empty for general documentation files
    const fileName = "Intro"; 
    useEffect(()=>{
        if (markdown.length === 0) {
            setSelectedFile(fileName); 
            GetMarkdownFile(initialSoftwareKey, fileName, setMarkdown)
        }
    }, [setSelectedFile, markdown])

    return (
        <div style={{
            display:'grid',
            gridTemplateColumns:'200px 10px auto',
            gridTemplateRows: 'auto, auto', 
            textAlign:'left',
            gridColumnGap:'10px',
            margin:'40px',
        }}>
            <div>
                <DocumentNavigation
                    selectedFile={selectedFile}
                    markdown={markdown}
                    setSelectedFile={setSelectedFile}
                    setMarkdown={setMarkdown}
                    entitledProductNames={entitledProductNames}/>
            </div>
            <hr style={{height:'90%', border:'0.5px solid #3c3c3c'}}/>
            <div>
                <DocumentView markdown={markdown}/>
            </div>

        </div>
    )
}


export default DocumentationPage
